import {
  Button, Flex, Link,
  Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

const FreemiumExpiredModal = ({isOpen, onOpen, onClose, user}) => {
  const initialRef = React.useRef();
  const finalRef = React.useRef();

  const [isStarted, setIsStarted] = useState(false);


  const history = useHistory();


  return (
    <>
      <Modal
        size='lg'
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay/>
        <ModalContent borderRadius="lg" maxW="md">
          <ModalHeader fontWeight="bold">Realtime notuleren</ModalHeader>
          <ModalCloseButton/>

          <ModalBody>
            <Flex py={2}>
              <Text fontWeight={"normal"} fontSize={"sm"}>
                Omdat u geen premium gebruiker bent, en u door uw gratis minuten heen bent, kunt u geen gebruik meer maken
                van deze functionaliteit.
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Link href={"/admin/dashboard/subscription"}>
              <Button
                isDisabled={isStarted}
                textColor="white"
                bg="var(--primary-color)" w="100%"
                onClick={() => {
                  console.log("clicked")
                }}
                _hover={{
                  bg: "rgba(255, 0, 0, 0.3)",
                }}
              >
                Premium gebruiker worden
              </Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default FreemiumExpiredModal;
